'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const fastdom=require('fastdom');
const FileSaver=require('file-saver');
const BaseControllerBackedDirective=require('../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

PdfViewerDirective=function(_BaseControllerBacked){_inherits(PdfViewerDirective,_BaseControllerBacked);function PdfViewerDirective(){_classCallCheck(this,PdfViewerDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(PdfViewerDirective,[{key:'template',get:function()
{
return'<h3 ng-if="controller.isIE && controller.blob">Please <a ng-click="controller.downloadPdf()">click here</a> to download your report.</h3>';
}},{key:'textBindings',get:function()

{return['pdfData','fileName']}},{key:'controller',get:function()
{return PdfViewerController}}]);return PdfViewerDirective}(BaseControllerBackedDirective);let


PdfViewerController=function(){_createClass(PdfViewerController,null,[{key:'$inject',get:function()
{return['$timeout','$scope','$element']}}]);
function PdfViewerController($timeout,$scope,$element){var _this2=this;_classCallCheck(this,PdfViewerController);
this._$timeout=$timeout;
this._$scope=$scope;
this._$element=$element;
this._alreadyInitialized=!1;

this.downloadPdf=function(){return _this2._downloadPdf()};

$scope.$watch('controller.pdfData',function(newPdfData,oldPdfData){

if(_this2._alreadyInitialized||!_.exists(_this2.pdfData)||_this2.pdfData===''){
return;
}

_this2._populateData();
});
}PdfViewerController.prototype.

_populateData=function _populateData(){var _this3=this;
if(this._alreadyInitialized){
return;
}
this._alreadyInitialized=!0;

this._blob=b64toBlob(this.pdfData,'application/pdf',this.fileName);
this._blobObjectUrl=URL.createObjectURL(this._blob);

if(_.exists(window,'navigator.msSaveOrOpenBlob')){
this.isIE=!0;
this._downloadPdf();
return;
}

fastdom.mutate(function(){
angular.element(_this3._$element).html(`<object data="${_this3._blobObjectUrl}" type="application/pdf"></object>`);
});
};PdfViewerController.prototype.









_downloadPdf=function _downloadPdf(){
FileSaver.saveAs(this._blob,this.fileName);
};_createClass(PdfViewerController,[{key:'blob',get:function(){return this._blob}},{key:'blobObjectUrl',get:function(){return this._blobObjectUrl}}]);return PdfViewerController}();


function b64toBlob(b64Data,contentType,fileName){
let sliceSize=512;

var byteCharacters=atob(b64Data);
var byteArrays=[];

for(var offset=0;offset<byteCharacters.length;offset+=sliceSize){
var slice=byteCharacters.slice(offset,offset+sliceSize);
var byteNumbers=Array(slice.length);
for(var i=0;i<slice.length;i++){
byteNumbers[i]=slice.charCodeAt(i);
}

var byteArray=new Uint8Array(byteNumbers);
byteArrays.push(byteArray);
}

var blob=new Blob(byteArrays,{type:contentType},fileName);
return blob;
}

module.exports=PdfViewerDirective;
//# sourceMappingURL=pdfViewerDirective.js.map
